
<div class="container" [ngClass]="'container-150'"   >
	<span class="titulo"><strong>{{item.titulo}}</strong></span>

	<span class="fecha">{{item.fecha}}</span>

	<svg  class="svg-class" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 87.6 125.7" style="enable-background:new 0 0 87.6 125.7;" xml:space="preserve">
<style type="text/css">

   .st1{fill:#FFFFFF;}
   .st2{fill:#1F2549;}
   .st3{font-family:'MyriadCAD';}


</style>
<rect id="linea" y="28.7"  [ngClass]="(state==0)? 'st0': (state==1)? 'st0_active': 'st0_fail' "  width="87.6" height="15"/>
<g>
   <ellipse id="circulo" [ngClass]="(state==0)? 'st0': (state==1)? 'st0_active': 'st0_fail' " cx="44" cy="36.2" rx="24.1" ry="24.1"/>
   <ellipse class="st1" cx="44" cy="36.2" rx="18.5" ry="18.5"/>
</g>
<g>
   <text transform="matrix(1 0 0 1 37.7355 41.6527)" [ngClass]="(state==0)? 'st0': (state==1)? 'st0_active': 'st0_fail' " class="st2 st3 st4">{{number}}</text>
</g>
<g id="check">
   <path [ngClass]="(state==0)? 'st0': (state==1)? 'st0_active stshow': 'st0_fail stshide' " d="M63.1,61.9c-1.1,0-2.5,0.1-4.2,0.4c-1.7,0.3-2.9,0.6-3.6,1s-1.8,1.3-3.3,2.9c-1.5,1.5-3.3,3.9-5.6,7.2
	   c-2.2,3.2-4.2,6.3-5.8,9.3c-1.5,2.6-3,5.5-4.5,8.6c-1.1-1.3-2.2-2.4-3.3-3.2c-1.4-1-2.8-1.5-4.1-1.5s-2.7,0.6-4.3,1.7
	   c-1.6,1.2-2.4,2.5-2.4,4c0,1.1,0.7,2.4,2.1,3.9c2,2.2,3.7,4.3,4.9,6.2c0.9,1.4,1.5,2.3,1.9,2.7c0.4,0.5,1,0.8,1.6,1
	   c0.6,0.2,1.6,0.3,3.1,0.3c2,0,3.4-0.2,4.2-0.7c0.8-0.4,1.5-1.1,1.9-1.9c0.4-0.7,1.1-2.2,2-4.4c2.3-5.6,5.3-11.5,9.1-17.5
	   c3.8-6,7.5-10.7,11-13.9c0.9-0.8,1.4-1.3,1.7-1.8c0.3-0.5,0.5-1,0.5-1.6c0-0.8-0.3-1.4-0.8-2C64.6,62.1,63.9,61.9,63.1,61.9z"/>
</g>
<g id="fail">
   <g>
	   <path [ngClass]="(state==0)? 'st0 stshide': (state==2)? 'st0_fail stshow': 'st0_active stshide' " d="M67.4,69.7c-1.3-0.3-2.9-0.4-4.9-0.5c-2.1-0.1-3.5,0-4.4,0.3s-2.4,1.1-4.5,2.6c-2.1,1.4-4.8,3.8-8.2,7
		   c-3.3,3.2-6.4,6.3-9,9.4c-2.3,2.7-4.8,5.7-7.2,8.9l0,0c-0.2,0.2-0.5,0.5-0.7,0.7c0,0,0,0.1-0.1,0.1c-2.4,2.9-5.7,8.1-4.6,12.2
		   c0.1,0.1,0.1,0.2,0.2,0.3c0.4,0.2,0.8,0.5,1.1,0.7c0.5,0.2,0.9,0.3,1.4,0.5c0.5,0,0.9,0.1,1.4,0.1c2.5-0.3,4.8-1,7-2.1
		   c0.4-0.3,0.7-0.7,1.1-1l0.1-0.1c4-6,8.9-12.1,14.7-18.2c5.8-6,11.2-10.6,16.1-13.5c1.2-0.7,1.9-1.2,2.3-1.7
		   c0.5-0.5,0.8-1.1,0.9-1.8c0.2-0.9,0-1.7-0.5-2.5C69.1,70.4,68.4,69.9,67.4,69.7z"/>
   </g>
   <g>
	   <path [ngClass]="(state==0)? 'st0 stshide': (state==2)? 'st0_fail stshow': 'st0_active stshide' "  d="M60.9,99.9c-1.4-2-3.6-4.6-6.7-7.8c-3-3.2-6-6-8.9-8.5c-2.5-2.1-5.2-4.3-8.1-6.5C37,77,36.9,77,36.7,76.8
		   c-2.4-2.4-5.1-3.7-8.3-5c-0.1,0-0.2-0.1-0.3-0.1c-1.3-0.3-2.7-0.4-3.9,0c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.6-0.5,1.3-0.7,1.9
		   c0,0.2-0.1,0.4-0.1,0.5c0,0.4-0.1,0.7-0.1,1.1c0.3,2.1,0.8,4,1.7,5.9c0.3,0.6,0.7,1.2,1.1,1.7c0.1,0.1,0.2,0.1,0.3,0.2
		   c5.7,3.8,11.5,8.5,17.3,14c5.7,5.5,10.1,10.7,12.9,15.3c0.7,1.1,1.2,1.8,1.6,2.2c0.4,0.4,1,0.7,1.7,0.9c0.8,0.2,1.6,0,2.4-0.4
		   c0.7-0.5,1.2-1.2,1.4-2.1c0.2-1.2,0.4-2.8,0.5-4.7c0.1-2,0-3.4-0.3-4.2C63.1,103.3,62.3,101.9,60.9,99.9z"/>
   </g>
</g>
<g>
   <path class="st5" d="M520.9-68.5c-3.7,0-8.4,0.4-13.9,1.3c-5.8,0.9-9.7,2-12.1,3.3c-2.4,1.3-6,4.5-11,9.8
	   c-4.9,5.1-11.1,13.1-18.5,23.9c-7.4,10.7-14,21.1-19.4,30.9C441,9.5,436,19.2,431,29.5c-3.5-4.4-7.2-8-11-10.6
	   c-4.8-3.3-9.4-5-13.7-5c-4.4,0-9.2,1.9-14.2,5.7c-5.3,3.9-7.9,8.4-7.9,13.3c0,3.7,2.3,8,7,13.1c6.8,7.5,12.3,14.4,16.4,20.7
	   c3,4.6,5.1,7.5,6.3,8.9c1.4,1.6,3.2,2.7,5.3,3.5c2,0.7,5.4,1.1,10.3,1.1c6.7,0,11.3-0.7,14.1-2.2c2.7-1.5,4.9-3.6,6.4-6.3
	   c1.4-2.4,3.5-7.2,6.5-14.7c7.5-18.8,17.8-38.4,30.4-58.4c12.6-19.9,25-35.5,36.8-46.4c2.9-2.6,4.6-4.5,5.5-5.9
	   c1-1.6,1.5-3.4,1.5-5.4c0-2.6-0.9-4.8-2.7-6.6C526.1-67.5,523.7-68.5,520.9-68.5z"/>
</g>
<g>
   <g>
	   <path class="st6" d="M756.3-63.8c-4.3-0.9-9.8-1.5-16.4-1.7c-6.9-0.3-11.7,0-14.8,0.9c-3.1,0.9-8,3.8-15.1,8.7
		   c-6.9,4.8-16,12.6-27.2,23.3C671.7-22,661.6-11.5,652.9-1.4c-7.8,9-15.9,19.1-24.1,29.8c0-0.1-0.1-0.1-0.1-0.2
		   c-0.8,0.8-1.6,1.6-2.3,2.5c-0.1,0.1-0.1,0.2-0.2,0.3c-8,9.5-19,27.1-15.3,40.7c0.2,0.4,0.4,0.7,0.6,1.1c1.3,0.7,2.5,1.5,3.7,2.4
		   c1.5,0.6,3,1.1,4.6,1.7c1.6,0.1,3.1,0.3,4.7,0.4c8.3-1.1,15.9-3.4,23.3-7.1c1.3-1.1,2.5-2.4,3.8-3.5c0.1-0.1,0.2-0.3,0.3-0.4
		   c13.2-20,29.7-40.3,49.2-60.5c19.4-20.1,37.4-35.3,53.6-45.1c4-2.4,6.4-4.1,7.8-5.5c1.5-1.6,2.5-3.6,3-5.9c0.6-3,0.1-5.8-1.5-8.3
		   C762.1-61.5,759.6-63.1,756.3-63.8z"/>
   </g>
   <g>
	   <path class="st6" d="M734.5,37c-4.6-6.5-12-15.2-22.2-25.9c-10.1-10.6-20.1-20.2-29.7-28.4c-8.2-7-17.2-14.4-26.9-21.8
		   c-0.6-0.2-1.1-0.5-1.7-1c-8.2-8.1-17.1-12.5-27.8-16.6c-0.3-0.1-0.6-0.3-0.9-0.5c-4.5-1.1-8.9-1.3-13,0c-0.5,0.3-1,0.6-1.5,0.9
		   c-0.8,2.1-1.6,4.3-2.3,6.4c-0.1,0.6-0.2,1.2-0.4,1.8c-0.1,1.2-0.2,2.4-0.3,3.6c0.9,7,2.7,13.5,5.5,19.7c1.1,2,2.3,3.9,3.8,5.6
		   c0.4,0.2,0.7,0.5,1.1,0.7c19,12.6,38.4,28.3,57.6,46.8c19.1,18.4,33.6,35.6,42.9,51.1c2.2,3.8,3.9,6.1,5.2,7.4
		   c1.5,1.5,3.4,2.4,5.6,2.9c2.8,0.6,5.5,0.1,7.9-1.5c2.4-1.6,4-3.9,4.6-7c0.8-4.1,1.4-9.3,1.6-15.6c0.3-6.6,0-11.2-0.9-14.1
		   C741.9,48.4,739.2,43.7,734.5,37z"/>
   </g>
</g>
</svg>




<span class="texto">{{item.texto}}</span>

</div>
